import AllMessages from './AllMessages';

export default AllMessages;
